import React from 'react';
import {Box, Button} from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import PublicIcon from '@mui/icons-material/Public';
import {PermissionCheck} from '../descriptor-types';

interface DescriptorActionsProps {
    permissions: PermissionCheck;
    onSave: () => void;
    onPublish: () => void;
}

/**
 * Component for descriptor action buttons (Save, Publish)
 */
export const DescriptorActions: React.FC<DescriptorActionsProps> = ({
    permissions,
    onSave,
    onPublish
}) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, p: 0.5, pr: 0 }}>
            <Button
                variant='contained'
                title='Publish Occurrence Report Descriptor'
                component='button'
                style={{ textTransform: 'none' }}
                onClick={onPublish}
                startIcon={<PublicIcon />}
                disabled={!permissions.canPublish}
            >
                Publish
            </Button>
            
            <Button
                variant='contained'
                title='Save Occurrence Report Descriptor'
                component='button'
                onClick={onSave}
                startIcon={<SaveAltIcon />}
                disabled={!permissions.canEdit}
            >
                Save
            </Button>
        </Box>
    );
};